import { Link } from 'react-router-dom';
import type { ArticleItem } from '@/mocks/category';

interface ArticleGridProps {
  articles: ArticleItem[];
  categorySlug: string;
}

export default function ArticleGrid({ articles, categorySlug }: ArticleGridProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {articles.map((article, index) => (
        <Link
          key={article.id}
          to="/category/all"
          className={`group cursor-pointer ${
            index === 0 ? 'lg:col-span-2 lg:row-span-2' : ''
          }`}
        >
          <article
            className={`bg-white rounded-lg overflow-hidden transition-transform duration-200 group-hover:-translate-y-1 h-full ${
              index === 0 ? 'lg:flex' : 'flex flex-col'
            }`}
          >
            <div className={`relative overflow-hidden ${index === 0 ? 'lg:w-3/5' : 'w-full'}`}>
              <img
                src={article.image}
                alt={article.title}
                title={`${article.title} - 吃瓜网站线路一`}
                className={`w-full object-cover transition-transform duration-500 group-hover:scale-105 ${
                  index === 0 ? 'h-full min-h-[320px]' : 'h-52 md:h-56'
                }`}
                loading={index > 2 ? 'lazy' : 'eager'}
              />
              <div className="absolute top-3 left-3">
                <span className="px-3 py-1 bg-primary-500 text-white text-xs font-medium rounded-full whitespace-nowrap">
                  {article.category}
                </span>
              </div>
              <div className="absolute top-3 right-3">
                <span className="px-3 py-1 bg-foreground-950/70 text-white text-xs font-bold rounded-full whitespace-nowrap">
                  🔥 {article.heat}
                </span>
              </div>
            </div>
            <div className={`p-5 flex flex-col justify-between ${index === 0 ? 'lg:w-2/5' : 'flex-1'}`}>
              <div>
                <h2 className={`font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors leading-snug line-clamp-3 mb-3 ${
                  index === 0 ? 'text-lg md:text-xl' : 'text-base'
                }`}>
                  {article.title}
                </h2>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-3 mb-4">
                  {article.summary}
                </p>
              </div>
              <div className="flex items-center justify-between pt-3 border-t border-background-100">
                <span className="text-xs text-foreground-400">{article.time}</span>
                <span className="text-xs text-primary-500 font-medium flex items-center gap-1">
                  阅读全文
                  <span className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-arrow-right-s-line text-xs"></i>
                  </span>
                </span>
              </div>
            </div>
          </article>
        </Link>
      ))}
    </div>
  );
}